import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "23",
      height: "23",
      x: ".5",
      y: ".5",
      fill: "#fff",
      rx: "5.5"
    }, null, -1),
    _createElementVNode("rect", {
      width: "23",
      height: "23",
      x: ".5",
      y: ".5",
      stroke: "#D6D6D6",
      rx: "5.5"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17.334 12H6.667m0 0 4 4m-4-4 4-4"
    }, null, -1)
  ]))]))
}
export default { render: render }